import type { ICellRendererParams } from 'ag-grid-community';
import type { Apmc } from '../../schema';

// Two-line APMC name + district·state subtitle (mirrors price-series).
export function ApmcLocationCell(p: ICellRendererParams<Apmc>) {
  if (!p.data) return null;
  const { name, districtName, stateName } = p.data;
  return (
    <div className="flex flex-col leading-tight">
      <span className="text-[13px] font-semibold text-foreground">{name}</span>
      <span className="mt-0.5 text-[11px] text-foreground-muted">
        {districtName} · {stateName}
      </span>
    </div>
  );
}
